<div class="herb-calendar-container">
  <div class="herb-calendar-header">
    <h2>Kräutersaisonkalender</h2>
    <p class="herb-calendar-intro">Entdecke, welche Kräuter gerade Saison haben, wann die beste Zeit für Ernte und Anbau ist.</p>
    <div class="herb-controls">
      <div class="month-selector">
        <button class="btn-secondary" (click)="prevMonth()" aria-label="Vorheriger Monat">←</button>
        <!-- Klasse für aktuellen Monat -->
        <span [ngClass]="{'actual-current-month': currentMonthIndex === actualCurrentMonthIndex}">
          {{ months[currentMonthIndex] }}
        </span>
        <button class="btn-secondary" (click)="nextMonth()" aria-label="Nächster Monat">→</button>
      </div>
    </div>
  </div>

  <div class="herb-calendar-content">
    <!-- Grid View -->
    <div class="herb-grid">
      <ng-container *ngIf="seasonalHerbs.length > 0; else noHerbs">
        <div class="herb-card" *ngFor="let herb of seasonalHerbs; let i = index" (click)="showHerbDetail(herb)" tabindex="0" (keydown.enter)="showHerbDetail(herb)">
          <div class="herb-card-image" [style.background-color]="getHerbColor(herb)">
            @if (i === 0) {
              <img
                fill
                [ngSrc]="imageService.getBaseOptimizedUrl(herb.imageUrl)"
                [alt]="herb.name"
                priority
                sizes="(max-width: 768px) 100vw, 50vw">
            } @else {
              <img
                fill
                [ngSrc]="imageService.getBaseOptimizedUrl(herb.imageUrl)"
                [alt]="herb.name"
                loading="lazy"
                sizes="(max-width: 768px) 100vw, 50vw">
            }
            <!-- Fallback: Initialen -->
            <span *ngIf="!herb.imageUrl">{{ herb.name.charAt(0) }}</span>
          </div>
          <div class="herb-card-content">
            <h3 class="herb-card-title">{{ herb.name }}</h3>
            <p class="herb-card-latin" *ngIf="herb.latinName">{{ herb.latinName }}</p>
            <div class="herb-season-tag" [ngClass]="{'peak-season': isInPeakSeason(herb)}">
              {{ isInPeakSeason(herb) ? '🌿 Hauptsaison' : '✓ Erntezeit' }}
            </div>
            <!-- Kurzbeschreibung, wenn vorhanden -->
            <p class="herb-card-description" *ngIf="herb.shortDescription">
              {{ herb.shortDescription | slice:0:80 }}{{ herb.shortDescription.length > 80 ? '...' : '' }}
            </p>
            <!-- Verbesserte Ernte-Indikatoren -->
            <div class="harvest-indicator-container">
              <div class="calendar-label">Erntemonate:</div>
              <div class="harvest-indicator" title="Erntemonate">
                <div *ngFor="let month of months; let i = index"
                     class="month-indicator"
                     [ngClass]="{
                       'active': isHarvestable(herb, i), 
                       'peak': herb.peakMonths?.includes(i + 1),
                       'current': i === currentMonthIndex
                     }"
                     [title]="months[i] + (isHarvestable(herb, i) ? (herb.peakMonths?.includes(i + 1) ? ' (Hauptsaison)' : ' (Ernte)') : '')">
                  <span class="month-letter">{{ months[i].charAt(0) }}</span>
                </div>
              </div>
            </div>
            <div class="herb-card-footer">
              <button class="details-btn">Details anzeigen</button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- No herbs template -->
    <ng-template #noHerbs>
      <div class="text-center no-herbs-message">
        <h3>Keine Kräuter zur Ernte</h3>
        <p>Im {{ months[currentMonthIndex] }} sind laut unserer Liste keine Kräuter erntereif.</p>
        <p>Versuche einen anderen Monat oder schaue dir die komplette Kräuterliste an.</p>
      </div>
    </ng-template>
  </div>

  <!-- Detail Popup -->
  <div class="herb-detail-popup" [ngClass]="{'active': showDetailPopup}" *ngIf="showDetailPopup && selectedHerb" (click)="closeDetailPopup()">
    <!-- Klick auf Inhalt verhindert Schließen -->
    <div class="herb-detail-content" (click)="$event.stopPropagation()">
      <button class="close-button" (click)="closeDetailPopup()" aria-label="Schließen">×</button>

      <div class="herb-detail-header">
        <div class="herb-detail-image" [style.background-color]="getHerbColor(selectedHerb)">
          <img *ngIf="selectedHerb.imageUrl" 
                [src]="imageService.getBaseOptimizedUrl(selectedHerb.imageUrl)" 
                [alt]="selectedHerb.name" 
                loading="eager"
                >
          
          <!-- Fallback -->
          <span *ngIf="!selectedHerb.imageUrl">{{ selectedHerb.name.charAt(0) }}</span>
        </div>
        <div class="herb-detail-info">
          <h2 class="herb-detail-title">{{ selectedHerb.name }}</h2>
          <p class="herb-detail-season">{{ selectedHerb.latinName }}</p>
          <!-- Ernte-Kalender -->
          <div class="herb-detail-calendar harvest-calendar">
             <p class="calendar-label">Ernte:</p>
            <div class="herb-detail-month" *ngFor="let month of months; let i = index">
              <span class="herb-detail-month-name">{{ month.substring(0, 3) }}</span>
              <div class="herb-detail-month-indicator"
                   [ngClass]="{'active': isHarvestable(selectedHerb, i), 'peak': selectedHerb.peakMonths?.includes(i + 1), 'current': i === currentMonthIndex}"
                   [title]="months[i] + (isHarvestable(selectedHerb, i) ? (selectedHerb.peakMonths?.includes(i + 1) ? ' (Hauptsaison)' : ' (Ernte)') : '')">
              </div>
            </div>
          </div>
          <div>
            <span class="monthly-filter" [ngClass]="{'peak-season': isInPeakSeason(selectedHerb)}" *ngIf="isInPeakSeason(selectedHerb)">🌿 Hauptsaison jetzt!</span>
            <span class="monthly-filter" *ngIf="!isInPeakSeason(selectedHerb) && isHarvestable(selectedHerb, currentMonthIndex)">✓ Derzeit erntbar</span>
          </div>
        </div>
      </div>

      <div class="herb-detail-body">
        <div class="herb-property">
          <h3 class="herb-property-title">Beschreibung</h3>
          <p>{{ selectedHerb.description }}</p>
          <a [routerLink]="['/', infoCategorySlug, selectedHerb.id]" >Mehr zur {{selectedHerb.name}} erfahren →</a>
        </div>

        <div class="herb-property">
          <h3 class="herb-property-title">Verwendung</h3>
          <p>{{ getUsesText(selectedHerb) }}</p>
        </div>

        <!-- Verbesserter Anbau & Pflanzzeit Abschnitt mit vertikaler Anzeige -->
        <div class="herb-property">
          <h3 class="herb-property-title">Anbau & Pflanzzeit</h3>
          <p>{{ selectedHerb.cultivation }}</p>
          <p *ngIf="selectedHerb.cultivationNotes" class="cultivation-notes"><em>Hinweis: {{ selectedHerb.cultivationNotes }}</em></p>
          <div *ngIf="getPlantingTimeText(selectedHerb) as plantingText">
            <p><strong>Pflanzkalender:</strong> {{ plantingText }}</p>
          </div>
          
          <!-- Einfache Erklärung der Anbaumethoden -->
          <div class="planting-methods-explanation">
            <h4>Was bedeuten die verschiedenen Anbaumethoden?</h4>
            <div class="planting-method">
              <strong>Vorkultur</strong>Samen drinnen in kleinen Töpfen pflanzen. Die Pflänzchen wachsen geschützt vor Kälte und können später nach draußen umziehen.
            </div>
            <div class="planting-method">
              <strong>Auspflanzen</strong>Die vorgezogenen Pflänzchen ins Beet oder in größere Töpfe im Freien setzen, wenn es warm genug ist.
            </div>
            <div class="planting-method">
              <strong>Direktsaat</strong>Samen direkt draußen in die Erde oder ins Beet säen. Keine Vorkultur nötig.
            </div>
          </div>
          
          <!-- Verbesserter vertikaler Pflanzkalender mit Legende statt Beschriftungen -->
          <div class="vertical-planting-calendar" *ngIf="hasPlantingData(selectedHerb)">
            <!-- Legende für den Pflanzkalender -->
            <div class="planting-calendar-legend">
              <div class="legend-item" *ngIf="hasSowingIndoors(selectedHerb)">
                <div class="legend-color vorkultur-color"></div>
                <div class="legend-text">Vorkultur</div>
              </div>
              <div class="legend-item" *ngIf="hasPlantingOut(selectedHerb)">
                <div class="legend-color auspflanzen-color"></div>
                <div class="legend-text">Auspflanzen</div>
              </div>
              <div class="legend-item" *ngIf="hasSowingOutdoors(selectedHerb)">
                <div class="legend-color direktsaat-color"></div>
                <div class="legend-text">Direktsaat</div>
              </div>
            </div>
            
            <div class="calendar-months-header">
              <div class="month-column" *ngFor="let month of months; let i = index" 
                  [ngClass]="{'current-month': i === currentMonthIndex}">
                {{ month.substring(0, 3) }}
              </div>
            </div>
            
            <!-- Nur noch die Monatsquadrate ohne Beschriftung für Vorkultur -->
            <div class="planting-row" *ngIf="hasSowingIndoors(selectedHerb)">
              <div class="month-squares">
                <div class="month-square" *ngFor="let month of months; let i = index"
                     [ngClass]="{'active vorkultur': isSowableIndoors(selectedHerb, i), 'current': i === currentMonthIndex}"
                     [title]="months[i] + (isSowableIndoors(selectedHerb, i) ? ' (Vorkultur)' : '')">
                </div>
              </div>
            </div>
            
            
            <!-- Nur noch die Monatsquadrate ohne Beschriftung für Auspflanzen -->
            <div class="planting-row" *ngIf="hasPlantingOut(selectedHerb)">
              <div class="month-squares">
                <div class="month-square" *ngFor="let month of months; let i = index"
                     [ngClass]="{'active auspflanzen': isPlantableOut(selectedHerb, i), 'current': i === currentMonthIndex}"
                     [title]="months[i] + (isPlantableOut(selectedHerb, i) ? ' (Auspflanzen)' : '')">
                </div>
              </div>
            </div>

            <!-- Nur noch die Monatsquadrate ohne Beschriftung für Direktsaat -->
            <div class="planting-row" *ngIf="hasSowingOutdoors(selectedHerb)">
              <div class="month-squares">
                <div class="month-square" *ngFor="let month of months; let i = index"
                      [ngClass]="{'active direktsaat': isSowableOutdoors(selectedHerb, i), 'current': i === currentMonthIndex}"
                      [title]="months[i] + (isSowableOutdoors(selectedHerb, i) ? ' (Direktsaat)' : '')">
                </div>
              </div>
            </div>

          </div>
        </div>
        <!-- Ende Anbau Abschnitt -->

        <div class="herb-property" *ngIf="selectedHerb.properties">
          <h3 class="herb-property-title">Eigenschaften</h3>
          <!-- <p>{{ selectedHerb.properties }}</p> -->
          <ul>
            <li *ngFor="let prop of selectedHerb.properties">
              {{ prop }}
            </li>
          </ul>
        </div>

        <div class="herb-property">
          <h3 class="herb-property-title">Erntezeit</h3>
          <p>{{ getHarvestTimeText(selectedHerb) }}</p>
        </div>

      </div>
    </div>
  </div>
</div>


